module.exports = __webpack_public_path__ + "static/media/pos.c8a2aa03.svg";